<template>
	<div id="budgetsModule">
		<budget-list-component></budget-list-component>
	</div>
</template>

<script>
import mixin from '@/mixins'
import axiosAction from '@/mixins/axiosAction.js'
import errors from '@/mixins/errors.js'

import BudgetListComponent from '@/components/BudgetListComponent.vue'

export default {
	name: 'BudgetsModule',
	mixins: [mixin, axiosAction, errors],
	data() {
		return {
		}
	},
	components: {
		'budget-list-component': BudgetListComponent
	},
	computed: {
	},
	methods: {
		axiosResultLocal(responseLocal, response) {
			switch (responseLocal) {
				case 'defaultFunction': this.defaultFunction(response); break;
				default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')', this.$options.name); break;
			}
		},
		initModuleLocal() {
		}
	},
	mounted() {
		this.initModule(this.$options.name)
	},
}	
</script>
